import { render, staticRenderFns } from "./ContactMiniFormComponent.vue?vue&type=template&id=60fd15fe&scoped=true&lang=pug"
import script from "./ContactMiniFormComponent.vue?vue&type=script&lang=ts"
export * from "./ContactMiniFormComponent.vue?vue&type=script&lang=ts"
import style0 from "./ContactMiniFormComponent.vue?vue&type=style&index=0&id=60fd15fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fd15fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60fd15fe')) {
      api.createRecord('60fd15fe', component.options)
    } else {
      api.reload('60fd15fe', component.options)
    }
    module.hot.accept("./ContactMiniFormComponent.vue?vue&type=template&id=60fd15fe&scoped=true&lang=pug", function () {
      api.rerender('60fd15fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/ContactMiniFormComponent.vue"
export default component.exports